<div class="flex flex-column">
  <span class="text-lg font-semibold" style="color: #343535;">
    <app-translate key="PAYMENT_INFORMATION"></app-translate>
  </span>
  <p-divider></p-divider>
</div>
@if (isIframePayment) {
  <app-provider-payment-iframe [paymentIFrameUrl]="paymentIFrameUrl"></app-provider-payment-iframe>
}

<div class="mt-2">
  @if (todaysChargesTotal() > 0 || isResidentialVideo) {
    <!-- Payment Required Template -->
    <div class="flex flex-column">
      <div class="due-today flex justify-content-between align-items-center px-2 py-3 mb-3">
        <div class="text-base font-semibold"><app-translate key="DUE_TODAY"></app-translate>: </div>
        <div style="font-size: 20px;" class="font-semibold">{{todaysChargesTotal() |
        currency}}</div>
        <!-- <a href="#" class="text-primary">Show Order Summary</a> -->
      </div>

      <div class="flex flex-column gap-3">
        <div class="flex justify-content-between align-items-center">
          <div class="flex flex-column">
            <span class="text-base font-semibold"><app-translate key="BILLING_INFORMATION"></app-translate></span>
          </div>
          @if (paymentAllowAchTodaysCharges) {
            <div class="flex align-items-center gap-2"
              >
              <span class="text-base font-semibold"><app-translate key="PAY_WITH_ACH"></app-translate></span>
              <p-toggleswitch [formControl]="payWithAchTodaysChargesControl"></p-toggleswitch>
            </div>
          }
        </div>
        <div>

        </div>
        @if (payWithAchTodaysChargesControl.value === true) {
          <app-ach-billing #todayChargesAchBilling>
          </app-ach-billing>
        } @else {
          <app-credit-card-billing [customerName]="customerName" #todayChargesCreditCardBilling
            [ServiceAvailabilityZipCode]="abpData?.[0]?.serviceAvailabilityZipCode"
            [PaymentZipMustMatchService]="abpData?.[0]?.paymentMustMatchZipCode">
          </app-credit-card-billing>
        }

        <div class="flex flex-column">
          <span class="text-base font-semibold"><app-translate key="PAYMENT_AUTHORIZATION"></app-translate></span>
          <p-button [label]="languageService.getTranslation('READ_TERMS_CONDITIONS')" [link]="true"
          styleClass="outline-none pl-0" (onClick)="paymentAuthorizationDialog = true"></p-button>
        </div>
        <div>
          <div class="mb-1 flex flex-row">
            <div class="flex align-items-center">
              <div
                [ngStyle]="{'border': showErrors && !termsAccepted ? '1px solid red' : 'none', 'display': 'inline-block', 'padding': '2px'}">
                <p-checkbox [(ngModel)]="termsAccepted" [binary]="true" inputId="binary" />
              </div>
              <label for="binary" class="font-light pl-2 pt-1 text-base">
                <app-translate key="AGREE_PAYMENT_TERMS"></app-translate>
              </label>
            </div>
          </div>
          @if (showErrors && !termsAccepted) {
            <small class="p-error"><app-translate key="MUST_AGREE_PAYMENT_TERMS"></app-translate></small>
          }
        </div>
      </div>
      <p-divider class="mb-5"></p-divider>
    </div>
  } @else {
    <!-- No Payment Required Template -->
    <div class="flex flex-column no-payment-due">
      <div class="text-base text-center mb-3"><app-translate key="NO_PAYMENT_DUE_TODAY"></app-translate></div>
      <div class="due-today flex justify-content-between align-items-center px-2 py-3 mb-3">
        <div class="text-base font-semibold"><app-translate key="DUE_TODAY"></app-translate>: </div>
        <div style="font-size: 20px;" class="font-semibold">{{0 | currency}}</div>
      </div>
    </div>
  }

</div>

@for (item of visibleAbpData(); track item) {
  @if (item.useAlternateComponent) {
    <app-alt-autopay-paperless-payment
      [todaysChargesApplicable]="todaysChargesTotal() > 0"
      [autopayEnrollementValid]="isAutopayPaperlessFormForComponentValidByIndex($index)"
      [ServiceAvailabilityZipCode]="item.serviceAvailabilityZipCode"
      [PaymentZipMustMatchService]="item.paymentMustMatchZipCode"
      [customerName]="customerName"
      [autopaySelection]="item.autopayEnrollment"
      [autopayEnrollmentTermsUrl]="item.autopayEnrollmentTerms"
      [paperlessEnrollmentTermsUrl]="item.paperlessEnrollmentTerms"
      [paymentAllowAch]="item.paymentAllowAch"
      [orderFlowType]="item.flowType">
    </app-alt-autopay-paperless-payment>
  } @else {
    <app-autopay-paperless-payment
      [todaysChargesApplicable]="todaysChargesTotal() > 0"
      [autopayEnrollementValid]="isAutopayPaperlessFormForComponentValidByIndex($index)"
      [ServiceAvailabilityZipCode]="item.serviceAvailabilityZipCode"
      [PaymentZipMustMatchService]="item.paymentMustMatchZipCode"
      [customerName]="customerName"
      [autopaySelection]="item.autopayEnrollment"
      [autopayEnrollmentTermsUrl]="item.autopayEnrollmentTerms"
      [paperlessEnrollmentTermsUrl]="item.paperlessEnrollmentTerms"
      [autopayConsentHtml]="item.autopayConsentHtml"
      [autopayTermsHtml]="item.autopayTermsHtml"
      [paperlessConsentHtml]="item.paperlessConsentHtml"
      [paymentAllowAch]="item.paymentAllowAch"
      [isOofAutopay]="item.isOofAutopay"
      [providerType]="item.providerLabel"
      [lockAutopayToggle]="item.lockAutopayToggle"
      [hidePaperless]="item.hidePaperless"
      [orderFlowType]="item.flowType">
    </app-autopay-paperless-payment>
  }

}

<div class="flex flex-column mt-5">
  <div class="mb-3">
    <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onSubmitClicked()"
      styleClass="p-button-lg w-full p-button-primary" />
  </div>
  <div class="mb-3">
    <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
      (onClick)="onCancelClick()" />
  </div>
</div>

<div class="flex flex-column mt-5">
  <span class="text-sm font-light">
    <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
  </span>
</div>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>

<p-dialog [header]="paymentErrorDialogTitle" [modal]="true" [(visible)]="paymentErrorDialogVisible"
  [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="border-round-3xl">
  <div class="flex flex-column gap-3">
    <div [innerHTML]="paymentErrorDialogMessage"></div>
    <div class="flex flex-1 gap-3 justify-content-end">
      <p-button [label]="languageService.getTranslation('OKAY')" styleClass="p-button-raised"
      (click)="this.paymentErrorDialogVisible = false" rounded="true"></p-button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="paymentAuthorizationDialog"
  [header]="languageService.getTranslation('PAYMENT_AUTHORIZATION_TERMS')"
  [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="border-round-3xl" appendTo="body" [modal]="true"
  [blockScroll]="true" [closeOnEscape]="false">
  <div class="terms-content max-h-70vh overflow-y-auto">
    <div>
      @if (isCommercial && dtvStreamPackageSelected) {
        <div [innerHTML]="paymentTerms"></div>
      } @else {
        <h4><app-translate key="PARTIES"></app-translate></h4>
        <p><app-translate key="PARTIES_DESCRIPTION"></app-translate></p>

        <h4><app-translate key="ONE_TIME_PAYMENT_AUTH"></app-translate></h4>
        <p><app-translate key="ONE_TIME_PAYMENT_AUTH_DESCRIPTION"></app-translate></p>

        <h4><app-translate key="PAYMENT_METHOD"></app-translate></h4>
        <p><app-translate key="PAYMENT_METHOD_DESCRIPTION"></app-translate></p>

        <h4><app-translate key="REVOCATION"></app-translate></h4>
        <p><app-translate key="REVOCATION_DESCRIPTION"></app-translate></p>

        <h4><app-translate key="GENERAL"></app-translate></h4>
        <p><app-translate key="GENERAL_DESCRIPTION"></app-translate></p>
      }
    </div>
  </div>
  <div class="flex flex-1 gap-3 justify-content-end">
    <p-button [label]="languageService.getTranslation('CLOSE')" [link]="true" styleClass="button"
      (click)="paymentAuthorizationDialog = false" />
  </div>
</p-dialog>